document.addEventListener("DOMContentLoaded", function () {

  const TIERS = [
    { maxCents: 9999,     id: "66814332043309", price: "$5.00"  },
    { maxCents: 19999,    id: "66814332076077", price: "$10.00" },
    { maxCents: 79999,    id: "66814332108845", price: "$15.00" },
    { maxCents: Infinity, id: "66814332141613", price: "$20.00" }
  ];

  const ALL_IDS     = TIERS.map(t => t.id);
  const RELOAD_KEY  = "jspp_reloaded_for";
  const DECLINE_KEY = "jspp_declined";

  let syncInProgress = false;
  let isOurAdd       = false;
  // Tracks whether protection was present in the last cart we observed.
  // Used to tell "customer just removed it" apart from "never added yet".
  let prevProtectionPresent = null;

  // ── Opt-out memory (per browser session) ──────────────────────────────
  // Set when the customer turns the toggle OFF or removes the protection line.
  // While set, the script will NOT auto-add protection. Cleared if they turn
  // it back on, or if the cart is emptied of real products.
  // (Use localStorage instead of sessionStorage below if you want the opt-out
  //  to persist across sessions/visits rather than just the current tab.)
  function isDeclined()   { try { return sessionStorage.getItem(DECLINE_KEY) === "1"; } catch (e) { return false; } }
  function setDeclined()  { try { sessionStorage.setItem(DECLINE_KEY, "1"); } catch (e) {} }
  function clearDeclined(){ try { sessionStorage.removeItem(DECLINE_KEY); } catch (e) {} }

  // ── Cart page detection + one-time reload (server-rendered rows) ───────
  function isCartPage() {
    return /\/cart\/?$/.test(window.location.pathname);
  }

  function reloadCartPageOnce(tierKey) {
    if (!isCartPage()) return;
    try {
      if (sessionStorage.getItem(RELOAD_KEY) === String(tierKey)) return;
      sessionStorage.setItem(RELOAD_KEY, String(tierKey));
    } catch (e) {}
    window.location.reload();
  }

  function clearReloadFlag() {
    try { sessionStorage.removeItem(RELOAD_KEY); } catch (e) {}
  }

  function dispatchCartRefresh() {
    document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
    document.dispatchEvent(new CustomEvent("theme:cart:refresh", { bubbles: true }));
  }

  function afterSwap(tier) {
    dispatchCartRefresh();
    reloadCartPageOnce(tier.id);
  }

  function afterRemoval() {
    dispatchCartRefresh();
    reloadCartPageOnce("removed");
  }

  // Inspect a cart returned by a NON-our cart-change call. If protection went
  // from present -> absent while real products remain, the customer removed it
  // manually -> remember the opt-out. Runs before any re-render, so it wins the
  // race against the auto-add path and survives a full page reload.
  function inspectCartForDecline(cart) {
    if (isOurAdd) return;                 // ignore our own swap/remove traffic
    if (!cart || !cart.items) return;     // /cart/add.js returns a line, not a cart
    var hasProt = cart.items.some(i => ALL_IDS.includes(String(i.id)));
    var nonProt = cart.items.filter(i => !ALL_IDS.includes(String(i.id)));

    if (nonProt.length === 0) {           // cart emptied -> fresh start next time
      clearDeclined();
      prevProtectionPresent = false;
      return;
    }
    if (prevProtectionPresent === true && !hasProt) {
      setDeclined();                      // customer removed protection
    }
    prevProtectionPresent = hasProt;
  }

  // ── Intercept fetch (string / URL / Request) ──────────────────────────
  (function interceptFetch() {
    const _fetch = window.fetch;
    window.fetch = function (url, opts) {
      const result = _fetch.apply(this, arguments);
      let u = "";
      if (typeof url === "string") u = url;
      else if (url && url.url)     u = url.url;
      else if (url && url.href)    u = url.href;

      if (u) {
        const isCartChange =
          u.indexOf("/cart/change") > -1 ||
          u.indexOf("/cart/update") > -1 ||
          u.indexOf("/cart/add")    > -1;
        if (isCartChange && !isOurAdd) {
          result.then(function (resp) {
            try {
              resp.clone().json().then(inspectCartForDecline).catch(function () {});
            } catch (e) {}
            setTimeout(checkTierChange, 400);
          });
        }
      }
      return result;
    };
  })();

  // ── Intercept XHR (backup for non-fetch cart calls) ───────────────────
  (function interceptXHR() {
    const open = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.__jsppUrl = url;
      return open.apply(this, arguments);
    };
    const send = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send = function () {
      const self = this;
      const u = self.__jsppUrl || "";
      if (typeof u === "string" &&
          (u.indexOf("/cart/change") > -1 ||
           u.indexOf("/cart/update") > -1 ||
           u.indexOf("/cart/add")    > -1) &&
          !isOurAdd) {
        self.addEventListener("load", function () {
          try { inspectCartForDecline(JSON.parse(self.responseText)); } catch (e) {}
          setTimeout(checkTierChange, 400);
        });
      }
      return send.apply(this, arguments);
    };
  })();

  function getTier(cents) {
    return TIERS.find(t => cents <= t.maxCents) || TIERS[TIERS.length - 1];
  }

  function getCart() {
    return fetch("/cart.js", { cache: "no-store" }).then(r => r.json());
  }

  function getSubtotal(cart) {
    return cart.items.reduce((sum, i) => {
      return ALL_IDS.includes(String(i.id)) ? sum : sum + i.final_line_price;
    }, 0);
  }

  function getProtectionItems(cart) {
    return cart.items.filter(i => ALL_IDS.includes(String(i.id)));
  }

  function removeAll(cart) {
    const items = getProtectionItems(cart);
    if (items.length === 0) return Promise.resolve();
    const updates = {};
    items.forEach(i => { updates[i.key] = 0; });
    isOurAdd = true;
    return fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ updates })
    }).then(r => r.json()).finally(function () {
      setTimeout(function () { isOurAdd = false; }, 800);
    });
  }

  function addTier(id) {
    isOurAdd = true;
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    }).then(r => r.json()).finally(function () {
      setTimeout(function () { isOurAdd = false; }, 800);
    });
  }

  // ── Element finders (incl. Shadow DOM) ────────────────────────────────
  function findAllToggles() {
    const results = [];
    document.querySelectorAll("#route-pack-protection_switch").forEach(el => results.push(el));
    document.querySelectorAll("*").forEach(function (el) {
      if (el.shadowRoot) {
        el.shadowRoot.querySelectorAll("#route-pack-protection_switch").forEach(inner => results.push(inner));
      }
    });
    return results;
  }

  function findAllLabels() {
    const results = [];
    document.querySelectorAll("#js-protection-price, .js-protection-price").forEach(el => results.push(el));
    document.querySelectorAll("*").forEach(function (el) {
      if (el.shadowRoot) {
        el.shadowRoot.querySelectorAll("#js-protection-price, .js-protection-price").forEach(inner => results.push(inner));
      }
    });
    return results;
  }

  function findAllHidden() {
    const results = [];
    document.querySelectorAll("#route-pack-protection_id").forEach(el => results.push(el));
    document.querySelectorAll("*").forEach(function (el) {
      if (el.shadowRoot) {
        el.shadowRoot.querySelectorAll("#route-pack-protection_id").forEach(inner => results.push(inner));
      }
    });
    return results;
  }

  // Force the visual switch with !important so theme CSS can't break the knob.
  function paintToggle(el, checked) {
    var label = el.closest("label");
    if (!label) return;
    var track = label.querySelector(".js-toggle-track");
    var knob  = label.querySelector(".js-toggle-knob");

    label.style.setProperty("position", "relative", "important");
    label.style.setProperty("display", "inline-block", "important");
    label.style.setProperty("width", "48px", "important");
    label.style.setProperty("height", "26px", "important");
    label.style.setProperty("flex", "0 0 auto", "important");

    if (track) {
      track.style.setProperty("display", "block", "important");
      track.style.setProperty("position", "absolute", "important");
      track.style.setProperty("top", "0", "important");
      track.style.setProperty("left", "0", "important");
      track.style.setProperty("right", "0", "important");
      track.style.setProperty("bottom", "0", "important");
      track.style.setProperty("border-radius", "26px", "important");
      track.style.setProperty("background-color", checked ? "#e02020" : "#ccc", "important");
      track.style.setProperty("z-index", "1", "important");
      track.style.setProperty("transition", "background-color .25s ease", "important");
    }
    if (knob) {
      knob.style.setProperty("display", "block", "important");
      knob.style.setProperty("position", "absolute", "important");
      knob.style.setProperty("top", "auto", "important");
      knob.style.setProperty("bottom", "3px", "important");
      knob.style.setProperty("left", checked ? "25px" : "3px", );
      knob.style.setProperty("width", "20px", "important");
      knob.style.setProperty("height", "20px", "important");
      knob.style.setProperty("background-color", "#ffffff", "important");
      knob.style.setProperty("border-radius", "50%", "important");
      knob.style.setProperty("box-shadow", "0 1px 3px rgba(0,0,0,.3)", "important");
      knob.style.setProperty("z-index", "2", "important");
      knob.style.setProperty("transition", "left .25s ease", "important");
    }
  }

  function updateAllToggles(checked, disabled) {
    findAllToggles().forEach(function (el) {
      el.checked  = checked;
      el.disabled = !!disabled;
      paintToggle(el, checked);
    });
  }

  function updateAllLabels(tier) {
    findAllLabels().forEach(el => { el.textContent = "From " + tier.price; });
  }

  function updateAllHidden(tier) {
    findAllHidden().forEach(el => { el.value = tier.id; });
  }

  // Detect a manual removal during a live sync (AJAX re-render case).
  function detectDecline(hasProt, nonProtLen) {
    if (nonProtLen === 0) { clearDeclined(); return; }
    if (prevProtectionPresent === true && !hasProt && !isOurAdd) setDeclined();
  }

  // ── Core sync ─────────────────────────────────────────────────────────
  function syncProtection() {
    if (syncInProgress) return;
    syncInProgress = true;

    getCart().then(function (cart) {
      const subtotal        = getSubtotal(cart);
      const tier            = getTier(subtotal);
      const protectionItems = getProtectionItems(cart);
      const nonProtection   = cart.items.filter(i => !ALL_IDS.includes(String(i.id)));
      const hasProt         = protectionItems.length > 0;

      detectDecline(hasProt, nonProtection.length);
      updateAllLabels(tier);
      updateAllHidden(tier);

      // No real products -> remove protection, reset opt-out
      if (nonProtection.length === 0) {
        clearDeclined();
        updateAllToggles(false, false);
        prevProtectionPresent = false;
        syncInProgress = false;
        if (protectionItems.length > 0) removeAll(cart).then(afterRemoval);
        else clearReloadFlag();
        return;
      }

      // Customer opted out -> honor it: never auto-add, strip any leftover
      if (isDeclined()) {
        updateAllToggles(false, false);
        syncInProgress = false;
        if (protectionItems.length > 0) {
          removeAll(cart).then(function () {
            prevProtectionPresent = false;
            afterRemoval();
          });
        } else {
          prevProtectionPresent = false;
          clearReloadFlag();
        }
        return;
      }

      // Correct single protection item -> nothing to do
      if (protectionItems.length === 1 && String(protectionItems[0].id) === tier.id) {
        updateAllToggles(true, false);
        prevProtectionPresent = true;
        clearReloadFlag();
        syncInProgress = false;
        return;
      }

      // Wrong tier or duplicates -> swap
      if (protectionItems.length >= 1) {
        updateAllToggles(true, true);
        removeAll(cart)
          .then(function () { return addTier(tier.id); })
          .then(function () {
            updateAllToggles(true, false);
            prevProtectionPresent = true;
            syncInProgress = false;
            afterSwap(tier);
          })
          .catch(function () { syncInProgress = false; });
        return;
      }

      // No protection yet -> auto-add
      updateAllToggles(true, true);
      addTier(tier.id)
        .then(function () {
          updateAllToggles(true, false);
          prevProtectionPresent = true;
          syncInProgress = false;
          afterSwap(tier);
        })
        .catch(function () {
          updateAllToggles(false, false);
          syncInProgress = false;
        });

    }).catch(function () { syncInProgress = false; });
  }

  // ── Tier check after a cart change ────────────────────────────────────
  function checkTierChange() {
    if (syncInProgress) return;

    getCart().then(function (cart) {
      const subtotal        = getSubtotal(cart);
      const tier            = getTier(subtotal);
      const protectionItems = getProtectionItems(cart);
      const nonProtection   = cart.items.filter(i => !ALL_IDS.includes(String(i.id)));
      const hasProt         = protectionItems.length > 0;

      detectDecline(hasProt, nonProtection.length);
      updateAllLabels(tier);
      updateAllHidden(tier);

      if (nonProtection.length === 0) {
        clearDeclined();
        updateAllToggles(false, false);
        prevProtectionPresent = false;
        if (protectionItems.length > 0) removeAll(cart).then(afterRemoval);
        else clearReloadFlag();
        return;
      }

      // Opted out -> keep off, do not re-add
      if (isDeclined()) {
        updateAllToggles(false, false);
        if (protectionItems.length > 0) {
          removeAll(cart).then(function () {
            prevProtectionPresent = false;
            afterRemoval();
          });
        } else {
          prevProtectionPresent = false;
          clearReloadFlag();
        }
        return;
      }

      if (protectionItems.length === 0) {
        syncProtection();   // not declined -> let core logic add it
        return;
      }

      // Tier changed -> swap then refresh the visible row
      if (String(protectionItems[0].id) !== tier.id) {
        syncInProgress = true;
        updateAllToggles(true, true);
        removeAll(cart)
          .then(function () { return addTier(tier.id); })
          .then(function () {
            updateAllToggles(true, false);
            prevProtectionPresent = true;
            syncInProgress = false;
            afterSwap(tier);
          })
          .catch(function () { syncInProgress = false; });
      } else {
        prevProtectionPresent = true;
        clearReloadFlag();
      }
    });
  }

  // ── Manual toggle ─────────────────────────────────────────────────────
  function handleToggleChange(toggle) {
    if (toggle.disabled) return;
    updateAllToggles(toggle.checked, true);

    if (toggle.checked) {
      clearDeclined();    // customer opted back in
    } else {
      setDeclined();      // customer opted out
    }

    getCart().then(function (freshCart) {
      const freshTier = getTier(getSubtotal(freshCart));
      updateAllLabels(freshTier);
      updateAllHidden(freshTier);

      if (toggle.checked) {
        removeAll(freshCart)
          .then(function () { return addTier(freshTier.id); })
          .then(function () {
            updateAllToggles(true, false);
            prevProtectionPresent = true;
            afterSwap(freshTier);
          });
      } else {
        removeAll(freshCart).then(function () {
          updateAllToggles(false, false);
          prevProtectionPresent = false;
          afterRemoval();
        });
      }
    });
  }

  document.addEventListener("change", function (e) {
    if (e.target && e.target.id === "route-pack-protection_switch") {
      handleToggleChange(e.target);
    }
  });

  function bindShadowToggle(shadowRoot) {
    if (!shadowRoot || shadowRoot._protectionBound) return;
    shadowRoot._protectionBound = true;
    shadowRoot.addEventListener("change", function (e) {
      if (e.target && e.target.id === "route-pack-protection_switch") {
        handleToggleChange(e.target);
      }
    });
  }

  function waitForToggleAndSync(attempts) {
    attempts = attempts || 0;
    if (attempts > 40) return;
    if (findAllToggles().length === 0) {
      setTimeout(function () { waitForToggleAndSync(attempts + 1); }, 100);
      return;
    }
    syncProtection();
  }

  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType !== 1) continue;

        var isDrawer  = node.tagName && node.tagName.toLowerCase() === "cart-notification-drawer";
        var hasToggle = node.querySelector && node.querySelector("#route-pack-protection_switch");

        if (isDrawer || hasToggle) {
          if (node.shadowRoot) bindShadowToggle(node.shadowRoot);

          var attempts = 0;
          var pollShadow = setInterval(function () {
            attempts++;
            if (node.shadowRoot) {
              bindShadowToggle(node.shadowRoot);
              clearInterval(pollShadow);
            }
            if (attempts > 20) clearInterval(pollShadow);
          }, 50);

          setTimeout(function () { syncProtection(); }, 100);
          return;
        }
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

  document.querySelectorAll("cart-notification-drawer").forEach(function (el) {
    if (el.shadowRoot) bindShadowToggle(el.shadowRoot);
    new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        if (m.attributeName === "open" && el.hasAttribute("open")) {
          setTimeout(function () { syncProtection(); }, 150);
        }
      });
    }).observe(el, { attributes: true, attributeFilter: ["open"] });
  });

  // ── Initial sync ──
  waitForToggleAndSync();

});